import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=8eea7aac&"
import script from "./OptionCard.vue?vue&type=script&lang=ts&"
export * from "./OptionCard.vue?vue&type=script&lang=ts&"
import style0 from "./OptionCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VImg})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eea7aac')) {
      api.createRecord('8eea7aac', component.options)
    } else {
      api.reload('8eea7aac', component.options)
    }
    module.hot.accept("./OptionCard.vue?vue&type=template&id=8eea7aac&", function () {
      api.rerender('8eea7aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/dashboard/components/OptionCard.vue"
export default component.exports